import { dateToServer } from 'helpers/formatters/date';
import { CalculationFrequency } from 'modules/BenchmarkForm';
import { BenchmarkTypes } from 'types/Benchmark';

const mapTimeWindow = (data: any) => {
  const timeWindow: any = {
    fromDate: dateToServer(new Date(data.fromDate)),
    pullForwardLength: data.numberPeriods,
  };
  if (data.returnComponent.includes('-')) {
    timeWindow.returnComponentBenchmarkId = data.returnComponent;
  } else {
    timeWindow.returnComponentResourceId = Number(data.returnComponent);
  }

  return timeWindow;
};

const parseBoolean = (value: string | boolean): boolean => {
  switch (typeof value) {
    case 'string':
      return JSON.parse(value);

    case 'boolean':
    default:
      return value;
  }
};

export function getBody(originalValues: any, newValues: any) {
  const timeWindows = newValues.timeWindows
    ? newValues.timeWindows.map(mapTimeWindow)
    : [];

  return {
    id: originalValues?.id,
    name: newValues.name,
    typeId: BenchmarkTypes.PullForward,
    calculationFrequencyId:
      newValues.calculationFrequency?.id ?? newValues.calculationFrequencyId,
    baseCurrencyCode: newValues.baseCurrencyCode,
    includeBookedValues: parseBoolean(newValues.includeBookedValues)
      ? true
      : false,
    portfolioAnalyticsCalendarId:
      newValues.calculationFrequencyId === CalculationFrequency.day ||
      newValues.calculationFrequency?.id === CalculationFrequency.day
        ? newValues.portfolioAnalyticsCalendarId
        : undefined,
    timeWindows,
    isLagged: parseBoolean(newValues.isLagged) ? true : false,
    customLagDate: newValues.customLagDate || null,
    description: newValues.description,
  };
}
